import { combineReducers } from 'redux';
import userPreferences from 'app/userPreferences/slices';
import settings from 'app/settings/slices';

import auth from 'app/auth/slices'; // new slice
import dashboard from 'features/dashboard/slices'; // new slice
import { baseApi } from 'services/baseApi';
import resource from 'app/resource/slices';
import { createAction } from '@reduxjs/toolkit';
import player from './playerReducer';
import brands from './brandReducer';
import brandSetting from './brandSettingReducer';
import translation from './translationReducer';
import notification from './notificationReducer';
import template from './templateReducer';
import fileManager from './fileManagerReducer';
import game from './gameReducer';
import promoCode from './promoCodeReducer';
import bonus from './bonusReducer';
import thirdPartyServices from './thirdPartyServicesReducer';
import cashBack from './cashBackReducer';
import referral from './referralReducer';
import blacklist from './blacklistReducer';
import tag from './tagReducer';
import brandPayment from './brandPaymentReducer';
import reporting from './reportingReducer';
import operatorLimit from './operatorLimitReducer';
import legalAgreement from './legalAgreementReducer';
import accountUpdate from './accountUpdateReducer';
import cashier from './cashierReducer';
import gameSegment from './gameSegmentReducer';
import playerSegment from './playerSegmentReducer';
import playerPerformance from './playerPerformanceReducer';
import systemConversion from './systemConversionReducer';
import gameManagement from './gameManagementReducer';
import overview from './overviewReducer';
import campaign from './campaignReducer';
import previousAccount from './previousAccountReducer';
import reasons from './reasonsReducer';
import taxes from './taxesReducer';
import lobbyManagement from './lobbyManagementReducer';
import brandMarket from './brandMarketReducer';
import exportCenter from './exportCenterReducer';
import playerWallet from './playerWalletReducer';
import betStatusCorrection from './betStatusCorrectionReducer';
import releaseNote from './releaseNoteReducer';
import playerSession from './playerSessionReducer';
import campaignV2 from './campaignV2Reducer';
import playerComplaint from './playerComplaintReducer';
import selfAssessment from './selfAssessmentReducer';
import systemSetting from './systemSettingReducer';
import userActions from './userActionsReducer';
import superiorCountries from './superiorCountriesReducer';

export const resetAppState = createAction('settings/resetState');

const appReducer = combineReducers({
  player,
  brands,
  brandSetting,
  brandMarket,
  translation,
  notification,
  template,
  fileManager,
  game,
  promoCode,
  bonus,
  thirdPartyServices,
  cashBack,
  referral,
  blacklist,
  tag,
  brandPayment,
  reporting,
  operatorLimit,
  legalAgreement,
  accountUpdate,
  cashier,
  gameSegment,
  playerSegment,
  playerPerformance,
  dashboard,
  systemConversion,
  gameManagement,
  overview,
  previousAccount,
  reasons,
  campaign,
  taxes,
  lobbyManagement,
  exportCenter,
  playerWallet,
  betStatusCorrection,
  releaseNote,
  playerSession,
  campaignV2,
  playerComplaint,
  selfAssessment,
  systemSetting,
  userActions,
  superiorCountries,
  [baseApi.reducerPath]: baseApi.reducer,
  auth,
  userPreferences,
  settings,
  resource,
});

const rootReducer = (state, action) => {
  if (resetAppState.match(action)) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

export default rootReducer;
